const Loader = () => {
  return (
    <div className="flex h-screen items-center justify-center ">
      <div className="relative">
        {/* Outer Ring */}
        <div className="h-16 w-16 border-4 border-[#e0e7ff] rounded-full"></div>

        {/* Spinning Overlay */}
        <div className="absolute top-0 left-0 h-16 w-16 border-4 border-[#405189] border-t-transparent rounded-full animate-spin"></div>
      </div>
    </div>
  );
};

export default Loader;
